import { programmeringByMin } from "../lib/data";
import { isCurrent } from "../lib/time";
import { Icon } from "./Icon";

// Volledige dagprogrammering van één area — gedeeld door de desktop-
// podiumtegels (sheet) en de mobiele StagesNow-accordion.

export function AreaTimetableList({
  venue,
  nowMin,
}: {
  venue: string;
  nowMin: number;
}) {
  const acts = programmeringByMin.filter(
    (p) => p.locatie.venue === venue && !p.is_overleg,
  );
  if (acts.length === 0) {
    return (
      <p className="text-sm text-zinc-500 px-1 py-2">
        Geen programmering bekend voor deze area.
      </p>
    );
  }
  return (
    <ul className="space-y-1">
      {acts.map((a) => {
        const live = isCurrent(a.vanMin, a.totMin, nowMin);
        const voorbij = a.totMin != null && nowMin >= a.totMin;
        return (
          <li
            key={a.id}
            className={`flex items-baseline gap-2 rounded px-1.5 py-1 text-sm ${
              live
                ? "bg-ok/10 text-zinc-100"
                : voorbij
                  ? "text-zinc-600"
                  : "text-zinc-300"
            }`}
          >
            <span className="font-mono tabular text-2xs shrink-0 w-[5.5rem]">
              {a.tijd_van}–{a.tijd_tot}
            </span>
            <span className="truncate">
              {a.has_aandacht && <span className="text-warn mr-1">⚠</span>}
              {a.wat}
            </span>
            {live && (
              <span className="ml-auto pill bg-ok/15 text-ok shrink-0">Live</span>
            )}
          </li>
        );
      })}
    </ul>
  );
}

export function AreaTimetableSheet({
  venue,
  nowMin,
  onClose,
}: {
  venue: string;
  nowMin: number;
  onClose: () => void;
}) {
  return (
    <div className="fixed inset-0 z-40 bg-ink-950/80 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div
        className="card w-full max-w-md max-h-[80vh] overflow-y-auto p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-3">
          <span className="eyebrow">{venue} · dagprogramma</span>
          <button
            onClick={onClose}
            aria-label="Sluiten"
            className="text-zinc-400 hover:text-zinc-200 p-2 -m-2"
          >
            <Icon.Close className="w-4 h-4" />
          </button>
        </div>
        <AreaTimetableList venue={venue} nowMin={nowMin} />
      </div>
    </div>
  );
}
